// Campos eSocial dos cadastros aparecem só quando o envio está habilitado para a empresa.
// A situação vem com os dados do usuário (login e troca de empresa) e fica no armazenamento local.
export default {
  computed: {
    envioEsocialAtivo() {
      return this.$store.state.inquilino?.esocialEnvioAtivo === true;
    },
  },
};
